import ToggleConfig from '../../../config/ToggleConfig';
import { GeneralBlock, o365Data } from '../../../reporter/report/Report';

function filtero365(
  o365: o365Data | undefined,
  toggle: ToggleConfig
): o365Data | undefined {
  if (!o365) {
    return o365;
  }
  const copy = {
    ...o365
  };
  if (!toggle.o365Oid) {
    delete copy.oid;
  }

  if (!toggle.o365UniqueUserDigest) {
    delete copy.uniqueUserDigest;
  }
  return copy;
}

function filterTitle(
  title: string | undefined,
  toggle: ToggleConfig
): string | undefined {
  if (!title || !toggle.eventTitle) {
    return undefined;
  } else {
    return title;
  }
}

export default function filterGeneral(
  general: GeneralBlock,
  toggle: ToggleConfig
): GeneralBlock {
  const o365 = filtero365(general.o365, toggle);
  const title = filterTitle(general.title, toggle);
  return new GeneralBlock({ ...general, o365, title });
}
